(function () {
  let sectionIdCache = null;

  function getSectionId() {
    if (sectionIdCache) return sectionIdCache;
    const el = document.querySelector('[data-product-card-rendering-section-id]');
    sectionIdCache = el ? el.dataset.productCardRenderingSectionId : 'product-card-rendering';
    return sectionIdCache;
  }

  function buildFetchUrl(productUrl) {
    const path = productUrl.startsWith('http') ? new URL(productUrl).pathname : (productUrl.startsWith('/') ? productUrl : '/' + productUrl);
    const sep = path.includes('?') ? '&' : '?';
    return path + sep + 'sections=' + encodeURIComponent(getSectionId());
  }

  function buildNavUrl(productUrl) {
    if (productUrl.startsWith('http')) return productUrl;
    return new URL(productUrl.startsWith('/') ? productUrl : '/' + productUrl, window.location.origin).href;
  }

  async function replaceCard(card, productUrl) {
    if (card.classList.contains('product-card--loading')) return;
    card.classList.add('product-card--loading');
    const sid = getSectionId();
    try {
      const res = await fetch(buildFetchUrl(productUrl));
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const html = data[sid] ?? data.sections?.[sid];
      if (!html) throw new Error('Section HTML not found');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCard = doc.querySelector('[data-product-card]') || doc.body.firstElementChild;
      newCard ? card.replaceWith(newCard) : (card.innerHTML = html);
    } catch {
      window.location.href = buildNavUrl(productUrl);
    } finally {
      card.classList.remove('product-card--loading');
    }
  }

  function onSwatchClick(e) {
    const swatch = e.target.closest('[data-product-card-swatch]');
    if (!swatch) return;
    const url = swatch.dataset.productUrl;
    if (!url) return;
    const card = swatch.closest('[data-product-card]');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    replaceCard(card, url);
  }

  function init() {
    document.addEventListener('click', onSwatchClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
